var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDogPaw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dog--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.41,415.72l-28.19-73.18-6.08,17.36L368.08,248.82,341.77,194.1l-48.09-21L239,192.46s-13.81,37-15.47,45.85,4.42,38.14,4.42,38.14l15.47,37,9.83,53.26s-3.75,29.09-3.22,44,7.53,45.76,7.53,45.76H462.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.08,436.44c.3-29.16-5.93-50.9-14.09-72.64a8.48,8.48,0,0,0-5.59-4.88c-4.61-1.28-8.63,3.08-11.76,6.68s-8.49,7.08-12.26,4.15c-4.19-3.26-1.12-9.89,2.15-14.08,6.32-8.08,12.68-16.34,16.41-25.9s7.52-20.75,2.78-29.85c-10.11,13.24-24.68,24.77-49.28,32.55-20.89,6.75-44.8,5.06-62.57,0,13,7.41,25.06,18.35,36,28.55,4.24,4,8.65,9.67,6.39,15-1.69,4-6.45,5.73-10.77,6.19s-8.86.16-12.82,2c-6.95,3.16-9.72,11.73-9.67,19.37.09,17.6,6.25,40.35,19.16,53H385.38C386.63,450.06,386,440.53,386.08,436.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.63,309.3s-.13.1-.41.25l-1.21.62c-.53.26-1.18.59-1.91,1s-1.59.84-2.49,1.39c-1.83,1.06-3.94,2.43-6.21,4.07a70.57,70.57,0,0,0-13.12,12.49,73.31,73.31,0,0,0-4.37,6c-.6.87-1.07,1.71-1.51,2.42s-.8,1.34-1.09,1.86l-.68,1.18c-.16.27-.25.41-.27.4a2.13,2.13,0,0,1,.18-.44l.59-1.24c.26-.53.59-1.18,1-1.91s.87-1.58,1.45-2.47a65.28,65.28,0,0,1,4.31-6.1,71.9,71.9,0,0,1,6.17-6.75,73,73,0,0,1,7-5.83,63.84,63.84,0,0,1,6.31-4c.91-.54,1.78-.95,2.53-1.33s1.42-.69,2-.92l1.26-.53A2.27,2.27,0,0,1,362.63,309.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.33,235.86a59.3,59.3,0,0,0-29.41-33.59s-3.7-5.57-15.5-16.56S303,167.12,287.16,165.6c-.63-.06-1.27-.1-1.93-.12-15.89-.41-39.9,11.2-39.9,11.2-15.27,4.23-35.19,33.08-39,44.46s-1.41,32.69-1.41,32.69-8.28,18.88-3.09,37.29C211,323.55,267,349.56,321.77,328.65S389.49,260.15,381.33,235.86Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.35,330.23c21.38-8,43.34-26.49,52.63-43.54,3.3-12.49,7-26.57,7-26.57l-15.45-48.43a61.29,61.29,0,0,0-6.92-5.52c-5.34.83-10.33,4.56-13.45,9.15-4.13,6.08-5.82,13.42-7.95,20.45s-5,14.24-10.71,18.87c-6.12,5-16.3,3.82-24.16,3.16.76,7.18,3.27,16.65,4,23.83l-14.59,4.43a71,71,0,0,1-10.9-22c-3.07,3.67-6.17,7.37-10,10.19s-8.61,4.7-13.36,4.22c-6.65-.67-11.92-5.66-17.77-8.92a36.77,36.77,0,0,0-28.27-3A36.4,36.4,0,0,0,200,272.4a76.75,76.75,0,0,0,1.81,18.72c3.61,17.55,22.63,33.09,44.7,39.8C266.86,337.11,294.92,340.07,321.35,330.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.74,277.65a29.93,29.93,0,0,0-11,2.24,16.6,16.6,0,0,0-8.23,7.42,8,8,0,0,0-.9,5.31c.8,3.47,4.5,5.3,7.78,6.67s7.1,2.85,10.68,1.95c2.69-.67,4.89-2.58,6.79-4.6,2.56-2.72,4.89-6,5.06-9.72s-1.57-9.34-10.18-9.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.54,298.64a10.86,10.86,0,0,1,.6,1.6,27.81,27.81,0,0,1,1.17,4.54,12.61,12.61,0,0,1-.66,6.91,8.09,8.09,0,0,1-2.5,3.33,9.87,9.87,0,0,1-4.08,1.81,20,20,0,0,1-8.51-.25,21.44,21.44,0,0,1-6.4-2.73,19.41,19.41,0,0,1-3.64-3,11.7,11.7,0,0,1-.84-.95,1.49,1.49,0,0,1-.26-.36,28.42,28.42,0,0,0,4.94,4,21.84,21.84,0,0,0,6.31,2.57,20,20,0,0,0,8.29.21,9.61,9.61,0,0,0,3.88-1.7,7.77,7.77,0,0,0,2.37-3.12,12.53,12.53,0,0,0,.73-6.67,34.3,34.3,0,0,0-1-4.53A10.93,10.93,0,0,1,304.54,298.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.56,302.47c0-.1.57.22,1.44.83a42.52,42.52,0,0,0,3.77,2.44,14.39,14.39,0,0,0,6.3,1.77,11.43,11.43,0,0,0,7.59-2.06,14.41,14.41,0,0,0,4.69-6.43,25.38,25.38,0,0,0,1.46-6.46c.2-1.89.26-3.43.32-4.49a11.19,11.19,0,0,1,.13-1.66,9.43,9.43,0,0,1,.07,1.66c0,1.07,0,2.62-.15,4.53a24.82,24.82,0,0,1-1.38,6.6,14.61,14.61,0,0,1-4.83,6.67A11.85,11.85,0,0,1,317,308a14.35,14.35,0,0,1-6.45-1.93,33.41,33.41,0,0,1-3.72-2.6A11.08,11.08,0,0,0,305.56,302.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.47,252.45a9,9,0,0,0-6.65-3.21,6.19,6.19,0,0,0-4.28,1.69h0a8.5,8.5,0,0,0-4,7.75,8.59,8.59,0,0,0,6.44,7.49,8.72,8.72,0,0,0,9.14-3.83A8.83,8.83,0,0,0,264.47,252.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.61,237.64a8.09,8.09,0,0,0-6.39-2.86,9.19,9.19,0,0,0-4.54,1.34h0a8.47,8.47,0,0,0-4,7.75,8.57,8.57,0,0,0,6.44,7.48,8.71,8.71,0,0,0,9.13-3.82A8.83,8.83,0,0,0,324.61,237.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.56,213.11l-2-1c-6.73-1.91-13.64,4.76-17.7,10a9.46,9.46,0,0,0-2.34,5.41c0,2.7,2,5,4.32,6.42,4.66,2.73,10.57,2.43,15.7.73,2.13-.71,4.31-1.75,5.5-3.66a9.17,9.17,0,0,0,1.11-4.92A21.29,21.29,0,0,0,257.56,213.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.28,201l2-1c6.73-1.91,13.64,4.76,17.7,10.06a9.28,9.28,0,0,1,2.34,5.4c0,2.71-2,5.06-4.32,6.42-4.65,2.74-10.57,2.44-15.69.73-2.14-.71-4.32-1.75-5.51-3.65a9.09,9.09,0,0,1-1.1-4.93A21.22,21.22,0,0,1,303.28,201Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.28,297.6a8.2,8.2,0,0,1-1.08-1.17,32.1,32.1,0,0,1-2.62-3.47,14.68,14.68,0,0,1-2.41-6,10.57,10.57,0,0,1,.21-3.86,23,23,0,0,1,1.37-3.88A69.26,69.26,0,0,1,277,266.83l2.5-3.53a9.48,9.48,0,0,1,1-1.27,8.64,8.64,0,0,1-.8,1.38c-.54.87-1.36,2.1-2.37,3.63a78.17,78.17,0,0,0-7,12.38,22.37,22.37,0,0,0-1.35,3.79,10.31,10.31,0,0,0-.24,3.68,15,15,0,0,0,2.25,5.87,43,43,0,0,0,2.46,3.55A9.94,9.94,0,0,1,274.28,297.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,275.93a12.05,12.05,0,0,1-.06-1.66,20.39,20.39,0,0,0-.48-4.47,8.63,8.63,0,0,0-1.21-2.8,7.24,7.24,0,0,0-2.59-2.29,18.15,18.15,0,0,0-3.65-1.44L319.93,262c-5.59-1.74-10.64-3.33-14.29-4.51l-4.32-1.43a10.11,10.11,0,0,1-1.56-.59,10.82,10.82,0,0,1,1.62.4l4.37,1.26c3.67,1.09,8.75,2.64,14.34,4.37l4.08,1.27a19.28,19.28,0,0,1,3.73,1.51,7.63,7.63,0,0,1,2.71,2.47,8.82,8.82,0,0,1,1.21,2.95,18.51,18.51,0,0,1,.32,4.56c0,.54-.05,1-.08,1.24S332,275.94,332,275.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.57,162.36c-6.31-1.64-14-1.89-18.36,2.93s-3.52,12.05-2,18.24a120.52,120.52,0,0,0,23.34,46.65l32.81-49.42C226.14,173.32,214.63,165.75,201.57,162.36Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.7,169.88c-3.83-1.36-8.8-1.85-11.31,1.35-2.27,2.9-1.15,7.12.29,10.52,5.1,12,12.09,25.19,22.09,33.52,4.85-10,10.5-19,17.56-26.26C220.17,181.65,210.06,173.55,199.7,169.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.56,203.18a6.08,6.08,0,0,1-.95-.94l-2.45-2.65c-2.15-2.32-5-5.36-8.14-8.73s-6-6.53-8-8.84c-1-1.16-1.8-2.1-2.33-2.77a6.24,6.24,0,0,1-.79-1.07,6,6,0,0,1,.94.93l2.45,2.66,8.14,8.73c3.19,3.41,6,6.53,8,8.84,1,1.15,1.79,2.1,2.33,2.77A7,7,0,0,1,217.56,203.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.06,138.07c-2.62-5.82-6.54-12.07-12.84-13.11S305.93,128.84,302,134c-8.15,10.75-12.51,23.82-16.73,36.63l53.44,18.07C337.25,170.27,338.25,154.05,331.06,138.07Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.11,138.78c2.17-3.44,5.77-6.9,9.72-5.94,3.58.87,5.31,4.88,6.28,8.43,3.41,12.56,6.07,26.74,3.38,39.47-8.47-5-18.36-8.58-29-11.48C300.29,158.43,302.25,148.08,308.11,138.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.8,174.63a5.88,5.88,0,0,1-.05-1.28c0-.82,0-2,.11-3.47.13-2.93.42-7,.8-11.44s.7-8.38.95-11.41c.11-1.38.2-2.54.27-3.46a6.71,6.71,0,0,1,.16-1.27,5.88,5.88,0,0,1,0,1.28c0,.82,0,2-.11,3.47-.13,2.94-.42,7-.8,11.44s-.7,8.38-.95,11.41c-.11,1.38-.2,2.54-.27,3.46A5.81,5.81,0,0,1,314.8,174.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.63,301.52a6.19,6.19,0,0,1-.66,1.11,22.73,22.73,0,0,1-2.4,2.84c-1.11,1.16-2.54,2.52-4.27,4-.86.75-1.8,1.54-2.81,2.36l-3.14,2.64a96.75,96.75,0,0,1-16.91,11.07,101.92,101.92,0,0,1-23.22,8.55,112.84,112.84,0,0,1-24.58,2.94,116.16,116.16,0,0,1-20.16-1.59,97.9,97.9,0,0,1-13.26-3.2c-1.52-.51-2.71-.91-3.49-1.23l-.9-.36-.3-.13a1.6,1.6,0,0,1,.32.08l.91.31c.8.29,2,.66,3.52,1.14a105.22,105.22,0,0,0,13.26,3,118.48,118.48,0,0,0,20.09,1.48,114.43,114.43,0,0,0,24.47-3,103.11,103.11,0,0,0,23.12-8.46,99.59,99.59,0,0,0,16.9-10.93l6-4.94c1.74-1.48,3.19-2.81,4.32-3.94a27.11,27.11,0,0,0,2.46-2.76C362.4,301.9,362.61,301.5,362.63,301.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.73,280.2a16.06,16.06,0,0,0-14,7,2,2,0,0,0-.44,1.78,1.43,1.43,0,0,0,1.45.77,4.14,4.14,0,0,0,1.64-.58l10.54-5.49a3.74,3.74,0,0,0,1.74-1.43c.35-.68.08-1.72-.67-1.86",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.35,183a8.16,8.16,0,0,1-1.37-.71c-.85-.49-2.1-1.19-3.66-2a119.65,119.65,0,0,0-25.54-10.25c-1.7-.47-3.08-.83-4-1.07a7.77,7.77,0,0,1-1.48-.43,9.51,9.51,0,0,1,1.52.23c1,.18,2.38.48,4.1.91A101.58,101.58,0,0,1,326.5,180c1.54.88,2.76,1.63,3.59,2.18A8.83,8.83,0,0,1,331.35,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.58,311.15a6.47,6.47,0,0,1-1.51,1.34,32.34,32.34,0,0,1-4.09,2.63,33.45,33.45,0,0,1-4.43,2,7,7,0,0,1-1.95.53c-.05-.15,2.83-1.18,6.13-3S318.48,311,318.58,311.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.24,185.85a8.57,8.57,0,0,1-1.11,1.23c-.75.77-1.81,1.89-3.09,3.31a105.93,105.93,0,0,0-16.67,24.55c-.84,1.71-1.5,3.11-1.94,4.08a9.77,9.77,0,0,1-.73,1.49,10,10,0,0,1,.55-1.56c.38-1,1-2.43,1.79-4.17a93,93,0,0,1,16.73-24.64c1.32-1.39,2.42-2.48,3.21-3.2A11.2,11.2,0,0,1,232.24,185.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.63,436.11s-.2,0-.58-.13l-1.68-.45c-1.46-.41-3.6-1-6.29-2a130.23,130.23,0,0,1-21.56-9.68l.26-.35A97.14,97.14,0,0,1,424.91,441l.48.78-.81-.42a78.8,78.8,0,0,1-14-9.09,80.58,80.58,0,0,1-11.28-11.17l.43-.27,7.8,18.51.31.74-.65-.46A69.8,69.8,0,0,1,389.25,421a54.84,54.84,0,0,1-4.71-8.65l.09.14c.06.12.13.26.23.44l.88,1.69c.8,1.48,2,3.63,3.73,6.23a70.61,70.61,0,0,0,17.95,18.45l-.34.27c-2.39-5.63-5-11.85-7.84-18.49l-.68-1.6,1.11,1.34a79.55,79.55,0,0,0,25.14,20.14l-.33.36a98.37,98.37,0,0,0-14-17.46l-1.18-1.16,1.44.82a137.34,137.34,0,0,0,21.42,9.83c2.68.95,4.8,1.62,6.25,2.08l1.65.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,291.63c-.81,7-3,16.65-3.34,23.62l3.91-5.95c1.17,18.18,4,40.65,6.59,58.68",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.2,368a.67.67,0,0,1-.06-.23c0-.18-.08-.4-.12-.67-.11-.63-.25-1.5-.42-2.59-.35-2.25-.83-5.51-1.39-9.55-1.11-8.07-2.55-19.24-3.73-31.62-.46-4.89-.84-9.61-1.12-14l.46.12c-1.38,2.07-2.69,4.06-3.93,5.94l-.47.7.05-.84a89.74,89.74,0,0,1,1.17-9.69c.5-2.85.94-5.35,1.3-7.43s.64-3.68.81-4.79c.08-.52.15-.94.2-1.27a2.72,2.72,0,0,1,.09-.43,1.34,1.34,0,0,1,0,.44c0,.29-.06.72-.13,1.28-.12,1.12-.35,2.75-.68,4.82s-.73,4.58-1.19,7.44a91.37,91.37,0,0,0-1.09,9.65l-.42-.14,3.89-5.95.41-.62.05.74c.29,4.38.68,9.09,1.14,14,1.18,12.37,2.56,23.54,3.58,31.62.51,4,.92,7.27,1.22,9.57.13,1.1.24,2,.32,2.61l.07.68A1,1,0,0,1,371.2,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385,412.91c-2.86-7.31-4-14.28-6.88-21.6.95,13.95,7.3,26.9,13.91,39.22a59.82,59.82,0,0,0,7.51,11.62c3.06,3.46,7,6.29,11.58,7.17a3.32,3.32,0,0,0,2.45-.23c1.45-.95.87-3.19,0-4.7s-2.46-7.75-2.46-7.75c7.4,5.18,18,11.37,26.95,12.31q-3.57-5.71-7.12-11.44A21.26,21.26,0,0,0,448,438.67c-11.35-4.39-24.85-9.4-36.19-13.79a85.89,85.89,0,0,1,12.87,16.29c-8.68-4-19.56-11.31-25.22-20.21,3.33,7.44,6.86,15.49,7.57,18.53-10.37-8-17.9-15.51-22.5-27.74"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M355.05,242.71a77.08,77.08,0,0,0,1.84,16.71c5.86,26.32,16.05,106,16.88,107,1,1.2,64.83,3.33,64.83,3.33l-10.44-13.39,9.16,3s-1.68-2.59-9.16-9.25c-10-8.9-24.15-117.66-24.15-117.66h0c1.82-14.85,3.64-29.74,3.5-44.69s-2.31-30-8.2-43.87a40.44,40.44,0,0,0-7.57-12.32c-3.37-3.53-7.47-3.38-12.21-4.89-8.5-2.7-13.93,1.18-18.3,6.1-3,3.35-3.22,7.28-5,11.37a12.3,12.3,0,0,0-4.13,5.83c-2.58,6.85-4.62,14-4.91,21.27s1.42,14.84,6,20.63l-4.35-2.4,7.93,8.7-2,3.81a12.17,12.17,0,0,0-1.41,7.31l3.28-3.48c-2,4.17-2.24,8.17-2.91,14.47-.31,2.82-.47,5.66-.51,8.49l-.14,9.87,1.91-1.6Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.7,251.3c6.66-.15,13.8,2.78,17.72,8,2.14,2.86,2.86,6.46,3.53,9.94q4.8,25.14,9.61,50.27c3.2,16.76,6.4,33.54,8.52,50.46,1.06,8.43,1.76,17.37-2,25.06-1.43,2.94-3.71,5.76-6.93,6.67-3.57,1-7.49-.63-10.08-3.22s-4.11-6-5.51-9.33a374.43,374.43,0,0,1-17-52.06c-7.17-28.09-6.61-42.58-9.42-71.38C368.22,265.72,367.84,251.56,379.7,251.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374,133.46c-1.89-1.72-5.06-1.55-7.18-.1a10.57,10.57,0,0,0-3.92,6.32,12,12,0,0,0-.1,6,7.44,7.44,0,0,0,3.67,4.74,5.64,5.64,0,0,0,5.92-.41c1.48-1.18,2.09-3.09,2.49-4.91.78-3.56,1.88-9.29-.88-11.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.38,151.11c-.32,0-4.31.7-5.75,5.89s-2.06,11.68,2.05,12.18,7.81.29,8.32-5.09S360.67,151,357.38,151.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.67,135.33c-.24,0-4.07-.77-5.82,2.65s-4.25,9.36-2.31,13.13,6.49,8.14,10.07,2.9,4.12-10.73,3.4-13.44S386.67,135.33,386.67,135.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,159c-.52.08-10.08,5-11.77,9.68s-.46,5.48,3.34,7.88a7.92,7.92,0,0,0,10.89-2.4C401.86,170.57,403.3,157.9,396.83,159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381,188.14c-.71-1.3-2.15-1.83-3.47-2.26l-8.4-2.74c-1.68-.55-3.69-1-5,.27l-2,.55a46.81,46.81,0,0,0,1.25,9.25,14.35,14.35,0,0,0,4.63,7.62,7.08,7.08,0,0,0,8,.75c2.59-1.61,3.8-5,4.82-8.08C381.32,191.76,381.87,189.73,381,188.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.71,167.85c-1.64,2.05-4.36,2.91-6.9,3.75s-5.23,1.89-6.61,4.12a7.91,7.91,0,0,0-.39,6.63,6.83,6.83,0,0,0,2.85,3.88c2.65,1.52,6.07.26,9.09.85,4.38.86,7.17,5.43,11.53,6.43,3.74.86,7.74-1.34,9.72-4.55a7,7,0,0,0,1.05-5.53c-.71-2.39-3-3.92-5.26-5.14s-4.64-2.48-5.8-4.69a21.13,21.13,0,0,1-1.19-3.92,5.08,5.08,0,0,0-2.33-3.28c-1.86-.91-4.13.15-5.6,1.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.94,238.18q-2.64-3.09-5.49-6L368.71,237a16.49,16.49,0,0,0,5.11,5.92,9.2,9.2,0,0,0,7.62,1.34c1.52-.47,3-1.69,2.95-3.23A4.74,4.74,0,0,0,382.94,238.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M376.75,231.94a6.48,6.48,0,0,0-5.65.38,4.82,4.82,0,0,0-2.31,4.88,6.33,6.33,0,0,0,2.84,3.78,11.66,11.66,0,0,0,8.87,1.69c1.58-.34,3.26-1.24,3.53-2.78a5.85,5.85,0,0,0-1.23-3.6,14.41,14.41,0,0,0-6.05-4.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.69,224.48s-.13-.07-.33-.24-.52-.42-.89-.77a32.55,32.55,0,0,1-3-3.15,36.5,36.5,0,0,1-6.76-12.53l.51-.07v0c0,1.39-.07,2.75-.11,4.06,0,.66,0,1.3-.06,1.93l0,.94a2.44,2.44,0,0,1-.17,1,1.19,1.19,0,0,1-.33.46.79.79,0,0,1-.61.14,1.29,1.29,0,0,1-.79-.65c-.31-.49-.61-1-.86-1.45a19.26,19.26,0,0,1-1.2-2.76,17.64,17.64,0,0,1-.88-4.26,10.85,10.85,0,0,1,0-1.18,1.2,1.2,0,0,1,0-.41,24.27,24.27,0,0,0,1.23,5.72,19.62,19.62,0,0,0,1.23,2.69c.26.46.55.92.86,1.4s.72.63.91.12a6.31,6.31,0,0,0,.15-1.75c0-.63,0-1.28,0-1.93,0-1.32.06-2.68.1-4.07v0l0-1.6.47,1.53a38.24,38.24,0,0,0,6.55,12.46c1.12,1.42,2.12,2.5,2.82,3.24A10.58,10.58,0,0,1,381.69,224.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.53,162.85a10.17,10.17,0,0,1-1.21-1.49l-3.07-4.15.37-.11c0,1.46-.07,3.09-.11,4.83v.61l-.41-.45a11.4,11.4,0,0,1-2.4-4.17l.48,0c-.32.73-.66,1.49-1,2.27l-.92,2.05-.17.38-.26-.32a5,5,0,0,1-.77-5l.37.28a29.66,29.66,0,0,1-5.34,3.32l-.46.23.21-.46a11.81,11.81,0,0,1,2.36-3.42,7.51,7.51,0,0,1,.84-.75c.2-.16.31-.23.33-.22s-.39.39-1,1.11a12.56,12.56,0,0,0-2.17,3.42l-.25-.23a32.84,32.84,0,0,0,5.2-3.38l.72-.57-.34.85a4.53,4.53,0,0,0,.71,4.47l-.43.06.91-2.05,1-2.27.28-.62.2.64a11.22,11.22,0,0,0,2.27,4l-.42.15c.07-1.75.13-3.37.19-4.83l0-.61.34.49,2.93,4.26A13.85,13.85,0,0,1,382.53,162.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.76,127.74a1.74,1.74,0,0,0-2.06,0,2.4,2.4,0,0,0-1.14,1.58.92.92,0,0,0,.26.91,1.68,1.68,0,0,0,1.27.36,2.34,2.34,0,0,0,1.8-.92A1.48,1.48,0,0,0,373.76,127.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.7,132.9a3.9,3.9,0,0,0-1.6-1.9.7.7,0,0,0-.57-.13c-.16.06-.52.18-.61.32a1.68,1.68,0,0,0-.23,1.39,2.34,2.34,0,0,0,2.4,1.44.9.9,0,0,0,.62-.3A.85.85,0,0,0,389.7,132.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365.28,316.82A98.72,98.72,0,0,0,371.21,365c-1.15-16.59-4-32.17-5.4-49.22"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M380.37,223.62A56.65,56.65,0,0,1,371,208.3a23.25,23.25,0,0,1-.33,6.33c-.06.43,0,1.31-.45,1.39s-1-.67-1.19-1a18.18,18.18,0,0,1-2.89-7.91l-.21.92a11.78,11.78,0,0,0,2.89,9.41,2.5,2.5,0,0,0,1.9,1,1.84,1.84,0,0,0,1.49-1.37,5.17,5.17,0,0,0,0-2.11A13.69,13.69,0,0,0,380.37,223.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M395.78,310.27a2.39,2.39,0,0,1-.44-.34c-.27-.23-.69-.57-1.18-1.05a42.57,42.57,0,0,1-4-4.3,46.31,46.31,0,0,1-8.88-17.43l.51-.09c.07.85.14,1.76.22,2.67a112.93,112.93,0,0,1,.18,11.81l0,.71-.4-.58A38.75,38.75,0,0,1,376,289.62a33.36,33.36,0,0,1-.82-3.73c-.07-.44-.1-.78-.13-1a1.82,1.82,0,0,1,0-.35,9.77,9.77,0,0,1,.31,1.33c.18.87.47,2.13.94,3.68a40.59,40.59,0,0,0,5.82,11.85l-.44.13c.11-3.61.06-7.59-.22-11.75-.08-.91-.15-1.81-.21-2.66l.5-.09a47.69,47.69,0,0,0,8.66,17.34,48.91,48.91,0,0,0,3.86,4.38c.47.5.87.86,1.12,1.12A3,3,0,0,1,395.78,310.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.9,390.59a6.31,6.31,0,0,1,.22,1.3c.11.85.2,2.07.27,3.58A64,64,0,0,1,435,418.82c-.49,1.43-.94,2.58-1.28,3.35a5.93,5.93,0,0,1-.58,1.19,6.87,6.87,0,0,1,.39-1.26c.28-.8.67-2,1.12-3.4a75.22,75.22,0,0,0,2.62-11.47,76.46,76.46,0,0,0,.76-11.75c0-1.5-.07-2.73-.12-3.57A7.11,7.11,0,0,1,437.9,390.59Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogPaw);
export default __webpack_public_path__ + "static/media/dog-paw.25735ef05d45a5a44299c08578d6110f.svg";
export { ForwardRef as ReactComponent };